export const ALL_CATEGORY = 'All';

export enum SalesforceActivityMatchingStatus {
  NoObjectsFound = 'noObjectsFound',
  FoundButNotOwned = 'foundButNotOwned',
  FoundAndOwned = 'foundAndOwned',
}

export enum SalesforceActivityTaskSubtype {
  Call = 'Call',
  Email = 'Email',
  Task = 'Task',
}

export type SalesforceEntity = {
  id: string;
  name: string;
  link: string;
};

export type SalesforceNormalizedEntity = SalesforceEntity & {
  description: string;
  subType: 'account' | 'lead';
  taskCount: number;
};

export type SalesforceAccount = SalesforceEntity & {
  type: string;
};

export type SalesforceLead = SalesforceEntity & {
  status: string;
};

export type SalesforceTaskBase = {
  id: string;
  subject: string;
  description?: string;
  status: string;
  activityDate?: string;
  ownerId: string;
  ownerName: string;
  taskSubtype: SalesforceActivityTaskSubtype;
};

export type SalesforceAccountTask = SalesforceTaskBase & {
  whatId: string;
};

export type SalesforceLeadTask = SalesforceTaskBase & {
  whoId: string;
};

export type SalesforceTask = SalesforceAccountTask | SalesforceLeadTask;

export type SalesforceActivityResponse = {
  accounts: readonly SalesforceAccount[];
  leads: readonly SalesforceLead[];
  tasks: readonly SalesforceTask[];
  matchingStatus: SalesforceActivityMatchingStatus;
};
